import { InfoCircledIcon } from '@radix-ui/react-icons';
import { HTMLAttributes, PropsWithChildren } from 'react';

import { FormControl, FormItem, FormMessage } from '../../../primitives/form';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../primitives/tooltip';
import { cn } from '../../../utils/cn';
import { FormLabelWithoutRef } from '../../label/label-without-ref';
import { Attribute } from './attribute';

interface FieldWrapperProps
  extends
    Pick<HTMLAttributes<HTMLDivElement>, 'className'>,
    Pick<Attribute, 'description' | 'label' | 'optionalLabel' | 'tooltip' | 'emailBuilder'> {}

export function FieldWrapper({
  children,
  className,
  description,
  emailBuilder,
  label,
  optionalLabel,
  tooltip,
}: PropsWithChildren<FieldWrapperProps>) {
  return (
    <FormItem className={className}>
      <div>
        {label ? (
          <div className="flex items-center">
            <FormLabelWithoutRef
              className={cn({
                'text-destructive': emailBuilder?.error,
              })}
            >
              {label}
              {optionalLabel ? (
                <span className="ml-1 text-xs text-muted-foreground">opcional</span>
              ) : null}
            </FormLabelWithoutRef>
            {tooltip?.title || tooltip?.content ? (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger className="ml-2">
                    <InfoCircledIcon className="size-4 text-accent" />
                  </TooltipTrigger>
                  <TooltipContent className="max-w-72 p-4">
                    <p>{tooltip?.title}</p>
                    <div>{tooltip?.content}</div>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            ) : null}
          </div>
        ) : null}
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
      </div>
      <div>
        <FormControl>{children}</FormControl>
        {emailBuilder?.error ? <FormMessage>{emailBuilder.error}</FormMessage> : null}
      </div>
    </FormItem>
  );
}
